import axios from '../localAxios';
import { workspaceMembersURL } from './workspacesURLs';

export interface WorkspaceMembersData {
  members: WorkspaceMember[];
  limits: {
    maxEditors: number;
    maxViewers: number;
  };
}

export interface WorkspaceMember {
  id: string;
  role: WorkspaceRole;
  status: WorkspaceMemberStatus;
  joinDate: string;
  fullName: string;
}

export enum WorkspaceRole {
  Owner = 3726,
  Editor = 1920,
  Viewer = 2834,
}

export enum WorkspaceMemberStatus {
  Inactive = 9826,
  Active = 8162,
}

export async function getWorkspaceMembers(workspaceId: string) {
  const url = workspaceMembersURL(workspaceId);
  const response = await axios.get<WorkspaceMembersData>(url.href);
  return response.data;
}
